<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">
       <el-row style="height: 36px">
          <el-form :inline="true" :model="searchCondition">

            <el-form-item class="elformItem"
              label="公司名称">
              <el-input  placeholder="请输入公司名称" clearable v-model="searchCondition.company_name"></el-input>
              <!-- <el-select :filterable="item.filterable" clearable @change="event_change(item)" v-if="item.type=='select'"
                :placeholder="item.placeholder?item.placeholder:item.label" v-model="item.val">
                <el-option v-for="(item_type,index_type) in item.typeData" :label="item_type.label"
                  :value="item_type.val" :key="index_type"></el-option>
              </el-select> -->

            </el-form-item>

            <el-form-item>
              <el-button @click="searchButton" style="color: #1890ff">查询</el-button>
            </el-form-item>

          </el-form>
        </el-row>

        <div style="text-align: right;margin: 5px 0;">
          <el-button v-if="userPermissions.indexOf('AutoExa_add') != -1" type="primary" @click="toggleOEMDialog('add')">新增白名单</el-button>
        </div>

        <ApeTable v-if="userPermissions.indexOf('AutoExa_list') != -1" ref="apeTable" :data="companyList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData"
          @switchPaging="switchPaging" highlight-current-row>
          <el-table-column v-if="buttonType=='text'" header_align='center' align='center' label="操作">
            <template slot-scope="scope">
              <span class="update-btn">
                <el-button size="mini" v-if="userPermissions.indexOf('AutoExa_edit') != -1" type="primary" @click="updateChannel(scope.row)">修改</el-button>
                <el-popover placement="top" width="150" v-model="scope.row.visible"> 
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
                    <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
                  </div>
                  <el-button slot="reference" type="danger" size="mini" v-if="userPermissions.indexOf('AutoExa_delete') != -1">删除</el-button>
                </el-popover>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
    <CreateEdit :dialog-data="openOEMDialog" ref="oemTable"
      @dialogConfirm="addSuccess" :cantEdit="cantEdit" :id='id' :buttonArr="buttonArr" :comData="comData"
      @dialogClose="dialogClose"></CreateEdit>
    <!-- <add-white-list ref='addWhiteList' title='添加董监高白名单' @refresh='init'></add-white-list> -->
  </div>
</template>

<script>
  import PageHeaderLayout from '@/layouts/PageHeaderLayout'
  import ApeTable from '@/components/ApeTable'
  import CreateEdit from './addWhiteList.vue'
  import DatePicker from '@/components/DatePicker.vue'
  import {
    mapGetters,
    mapState
  } from 'vuex'

  export default {
    components: {
      PageHeaderLayout,
      ApeTable,
      CreateEdit,
      DatePicker
    },
    data() {
      return {
        id: '',
        allCompany: [],
        allTaxSource: [],
        buttonArr: [{
          label: '确定',
          type: 'primary',
          flag: 'add'
        }],
        cantEdit: false,
        sccomData: [
          {
           label: '服务公司',
           field: 'company_name',
           val: '',
           required: true,
           placeholder: '请输入服务公司',
         }
        ],
        comData: [
          {
            label: '公司名称',
            field: 'company_id',
            val: '',
            required: true,
            placeholder: '请选择公司名称',
            type: 'select',
            typeData: [],
            filterable: true
          },
        ],
        openOEMDialog: {
          visible: false,
          width: '35%',
          loading: false,
          modal: true,
          confirmText: '提交',
          title: '新增税源地'
        },
        // 搜索条件
        searchCondition: {},
        loadingStaus: true,
        columns: [{
            title: '公司名称',
            value: 'company_name',
            width: 270,
            header_align: 'center',
            align: 'center',
          },
          {
            title: '创建时间',
            value: 'created_at',
            header_align: 'center',
            align: 'center',
          }
        ],
        // 表格列表数据
        companyList: [],
        // 分页信息
        pagingData: {
          is_show: true,
          layout: 'total, sizes, prev, pager, next, jumper',
          total: 0
        },
        // 分页的offset,序号列使用
        offset: 0,
      }
    },

    computed: {
      ...mapGetters(['userPermissions', 'buttonType']),
      ...mapState({
        userInfo: state => state.userInfo,
      }),
    },
    watch: {
      "$route.matched": function(n, o) {
        console.log(o)
        if (n.length === 2) {
          this.init()
        }
      }
    },
    methods: {

      // 相应删除按钮
      async deleteButton(id) {
        let result = await this.$api.delete_esign_whiteList(id)
        if (result) {
          await this.init()
        }
      },

      // 处理函数
      event_change() {

        // let obj = {}
        // this.sccomData.map((item) => {
        //   obj[item.field] = item.val
        //   if (obj[item.field] === '' || obj[item.field] === undefined) {
        //     delete obj[item.field]
        //   }
        // })

        // if (item.field == 'settlement_id') {
        //   this.searchCondition.company_id = ''
        //   this.allCompanyList('search')
        // }

        // this.searchCondition = obj
      },

      // async allTaxSourceList() {
      //   const result = await this.$api.tenantCategoryList()
      //   let allTaxSource = this.allTaxSource.concat(result)
      //   let arr = []

      //   allTaxSource.map(item => {
      //     let obj = {
      //       label: item.channel_name,
      //       val: item.channel_account
      //     }
      //     arr.push(obj)
      //   })
      //   // this.comData[0].typeData = arr
      //   this.sccomData[0].typeData = arr
      // },

      async allCompanyList() {
        let obj = {}

        // if (this.searchCondition.settlement_id) {
        //   obj.channel_account = this.searchCondition.settlement_id
        // }

        const data = await this.$api.companysBySett(obj);
        let allCompany = this.allCompany.concat(data)
        let arr = []
        allCompany.map(item => {
          let obj = {
            label: item.name,
            val: item.id
          }
          arr.push(obj)
        })
        // this.sccomData[0].typeData = arr
        this.comData[0].typeData = arr;
      },

      async updateChannel(e) {
        this.id = e.id.toString();
        let obj = {
          company_id:e.company_id
        }
        this.comData.map(item => {
          if (item.type == 'switch') {
            item.val = obj[item.field] == 1 ? true : false
          } else {
            item.val = obj[item.field]
          }
        })
        this.comData.map(item => {
          if (item.val === '') {
            item.val = '暂无'
          }
        })
        // if(settlement_id){
        //   this.allCompanyListEdit({
        //     settlement_id:settlement_id
        //   })
        // }
        this.toggleOEMDialog()
      },

      addSuccess() {
        this.dialogClose()
        this.init()
      },
      dialogClose() {
        this.id = ''
        this.comData[0].val = ''
        this.openOEMDialog.visible = false
      },

      toggleOEMDialog(type) {
        console.log(222);
        if (type === 'add') {
          this.openOEMDialog.title = `添加`
        } else {
          this.openOEMDialog.title = `修改`
        }
        this.openOEMDialog.visible = true
        // this.$refs.addWhiteList.open()
        
      },

      // 搜索
      searchButton() {
        console.log(this.searchCondition,'chaxun ');
        this.init('search')
      },
      // 切换页码操作
      async switchPaging() {
        this.init()
      },
      replaceStr(str) {
        const middleValue = str.substring(4, 14)
        return str = `****${middleValue}****`
      },
      // 初始化列表
      async init(type) {
        let pagingInfo = this.$refs['apeTable']?.getPagingInfo(type) || {
					page_size: 10,
					current_page: 1
				}
        if (type == 'export') {
          pagingInfo.page_size = 50000
        } else {
          this.loadingStaus = true
        }
        if (type == 'search') {
          pagingInfo.current_page = 1
        }
        let searchCondition = this.searchCondition.company_name == '' ? {} : this.searchCondition;
        Object.assign(searchCondition, pagingInfo)
        let {
          data,
          pages
        } = await this.$api.get_esign_whiteList(searchCondition)
        // data = data.filter((item) => {
        //   // return item.id_number = item.id_number.replace(/([\d]{4})\d{10}([\d]|[\s]{4})/, '$1*********$2')
        //   // item.id_number_text = this.replaceStr(item.id_number)
        //   return item
        // })
        data.forEach(ele => {
          ele.company_name = ele.company.name
        })

        this.companyList = []
        this.$nextTick(() => {
          this.companyList = data
        })
        this.pagingData.total = pages.total
        this.offset = pages.offset
        this.loadingStaus = false
      },

      keyupSubmit() {
        document.onkeydown = () => {
          let _key = window.event.keyCode;
          if (_key === 13) {
            this.searchButton()
          }
        }
      },
    },
    created() {
      this.keyupSubmit()
    },
    mounted() {
      this.allCompanyList()
      // this.allTaxSourceList()
      this.init()
    },
  }
</script>
<style lang="scss" scoped>
  .update-btn{
    /deep/ .el-button{
      margin-right: 10px;
    }
  }
</style>
